import bg2Logo from "../../assets/images/report_bg2_logo.svg";
import bgr from "../../assets/images/report_r.svg";
import bgr2 from "../../assets/images/report_r2.png";
import bge from "../../assets/images/report_e.svg";
import bge2 from "../../assets/images/report_e2.png";
import bga from "../../assets/images/report_a.svg";
import bga2 from "../../assets/images/report_a2.png";
import bgd from "../../assets/images/report_d.svg";
import bgd2 from "../../assets/images/report_d2.png";
import bg3Sample from "../../assets/images/report_bg3.svg";
import graph from "../../assets/images/graph.png";

import RR from "../../assets/images/report_RR.png";
import RE from "../../assets/images/report_RE.png";
import RA from "../../assets/images/report_RA.png";
import RD from "../../assets/images/report_RD.png";
import ER from "../../assets/images/report_ER.png";
import EE from "../../assets/images/report_EE.png";
import EA from "../../assets/images/report_EA.png";
import ED from "../../assets/images/report_ED.png";
import AR from "../../assets/images/report_AR.png";
import AE from "../../assets/images/report_AE.png";
import AA from "../../assets/images/report_AA.png";
import AD from "../../assets/images/report_AD.png";
import DR from "../../assets/images/report_DR.png";
import DE from "../../assets/images/report_DE.png";
import DA from "../../assets/images/report_DA.png";
import DD from "../../assets/images/report_DD.png";

import { Link, useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import ReportService from "../../services/ReportService";
import { useMst } from "../../models";
import Card, { CardBody } from "../../components/bootstrap/Card";
import PageWrapper from "../../layout/PageWrapper/PageWrapper";
import Page from "../../layout/Page/Page";
import basicBtn from "../../assets/images/report_basic_btn.svg";
import premiumBtn from "../../assets/images/report_premium_btn.svg";
import Icon from "../../components/icon/Icon";
import Button from "../../components/bootstrap/Button";

const Report = () => {
  const { user } = useMst();
  const location = useLocation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [type1, setType1] = useState("R"); 
  const [type, setType] = useState("R"); 
  const [payType, setPayType] = useState("free");
  const [message, setMessage] = useState(false);

  const reportData = {
    R: {
      label: '창조가',
      title: "창조가 라인이시군요!",
      bg: bgr,
      bg2: bgr2,
      color: "#B931F0",
    },
    E: {
      title: "상담가 라인이시군요!",
      bg: bge,
      bg2: bge2,
      color: "#19A87F",
    },
    A: {
      title: "행동가 라인이시군요!",
      bg: bga,
      bg2: bga2,
      color: "#E44251",
    },
    D: {
      title: "분석가 라인이시군요!",
      bg: bgd,
      bg2: bgd2,
      color: "#167FF0",
    },
    RR: {
      type: '창조가',
      en: "Revolutioner",
      detail: "님은 자신만의 독특한 관점으로\r\n세상을 바라보고 표현하는 창조가 유형에 속합니다.",
      tag: "#흥부자 #인간_비글미_폭발 \r\n\#내멋대로_내맘대로 #자유로운_영혼 #영혼까지_나나랜드\r\n#아이디어가_많다못해_넘쳐흐름 #창의력_끝판보스",
      detail2: "창조가 유형은 언제 어디서나 사람들의 시선을 신경 쓰지 않고 자유롭게\r\n자신을 드러내고, 생각을 표현하기 때문에 함께 하면 지루할 틈이 없는\r\n즐거운 사람들입니다.\r\n이들은 창조와 혁신을 통해 삶의 가치를 느끼기 때문에 늘 새로운 것에 \r\n도전합니다.또한 도전할 때 결과에 집중하기보다는 새로운 것을 경험하고 \r\n그 과정 자체를 즐길 줄 아는 사람입니다.그래서 새로운 자극을 끊임없이 \r\n추구합니다.세상에 대한 호기심도 많아 다양한 분야에 관심을 가집니다.",
      title: "오리지날 창조가 유형",
      card: RR,
      color: "#B931F0",
    },
    RE: {
      type: '창조가',
      en: "Revolutioner",
      detail: "님은 자신만의 독특한 관점으로\n\r세상을 바라보고 표현하는 창조가 유형에 속합니다.",
      tag: "#흥부자 #인간_비글미_폭발 \r\n\#내멋대로_내맘대로 #자유로운_영혼 #영혼까지_나나랜드\r\n#아이디어가_많다못해_넘쳐흐름 #창의력_끝판보스",
      detail2: "창조가 유형은 언제 어디서나 사람들의 시선을 신경 쓰지 않고 자유롭게\r\n자신을 드러내고, 생각을 표현하기 때문에 함께 하면 지루할 틈이 없는\r\n즐거운 사람들입니다.\r\n이들은 창조와 혁신을 통해 삶의 가치를 느끼기 때문에 늘 새로운 것에 \r\n도전합니다.또한 도전할 때 결과에 집중하기보다는 새로운 것을 경험하고 \r\n그 과정 자체를 즐길 줄 아는 사람입니다.그래서 새로운 자극을 끊임없이 \r\n추구합니다.세상에 대한 호기심도 많아 다양한 분야에 관심을 가집니다.",
      title: "오리지날 창조가 유형",
      card: RE,
      color: "#B931F0",
    },
    RA: {
      type: '창조가',
      en: "Revolutioner",
      detail: "님은 자신만의 독특한 관점으로\n\r세상을 바라보고 표현하는 창조가 유형에 속합니다.",
      tag: "#흥부자 #인간_비글미_폭발 \r\n\#내멋대로_내맘대로 #자유로운_영혼 #영혼까지_나나랜드\r\n#아이디어가_많다못해_넘쳐흐름 #창의력_끝판보스",
      detail2: "창조가 유형은 언제 어디서나 사람들의 시선을 신경 쓰지 않고 자유롭게\r\n자신을 드러내고, 생각을 표현하기 때문에 함께 하면 지루할 틈이 없는\r\n즐거운 사람들입니다.\r\n이들은 창조와 혁신을 통해 삶의 가치를 느끼기 때문에 늘 새로운 것에 \r\n도전합니다.또한 도전할 때 결과에 집중하기보다는 새로운 것을 경험하고 \r\n그 과정 자체를 즐길 줄 아는 사람입니다.그래서 새로운 자극을 끊임없이 \r\n추구합니다.세상에 대한 호기심도 많아 다양한 분야에 관심을 가집니다.",
      title: "오리지날 창조가 유형",
      card: RA,
      color: "#B931F0",
    },
    RD: {
      type: '창조가',
      en: "Revolutioner",
      detail: "님은 자신만의 독특한 관점으로\n\r세상을 바라보고 표현하는 창조가 유형에 속합니다.",
      tag: "#흥부자 #인간_비글미_폭발 \r\n\#내멋대로_내맘대로 #자유로운_영혼 #영혼까지_나나랜드\r\n#아이디어가_많다못해_넘쳐흐름 #창의력_끝판보스",
      detail2: "창조가 유형은 언제 어디서나 사람들의 시선을 신경 쓰지 않고 자유롭게\r\n자신을 드러내고, 생각을 표현하기 때문에 함께 하면 지루할 틈이 없는\r\n즐거운 사람들입니다.\r\n이들은 창조와 혁신을 통해 삶의 가치를 느끼기 때문에 늘 새로운 것에 \r\n도전합니다.또한 도전할 때 결과에 집중하기보다는 새로운 것을 경험하고 \r\n그 과정 자체를 즐길 줄 아는 사람입니다.그래서 새로운 자극을 끊임없이 \r\n추구합니다.세상에 대한 호기심도 많아 다양한 분야에 관심을 가집니다.",
      title: "오리지날 창조가 유형",
      card: RD,
      color: "#B931F0",
    },
    ER: ER,
    EE: EE,
    EA: EA,
    ED: ED,
    AR: AR,
    AE: AE,
    AA: AA,
    AD: {
      type: '행동가',
      en: "Guardian",
      detail: "님은 묵묵히 자기 사람들을\r\n보호하고 이끌어가는 보호자 유형에 속합니다.",
      tag: "#세상_시크한_수호신\r\n#빠르게_그러나_꼼꼼하게 #성격급한_완벽주의자\r\n#소리_없이_강하다 #묵직함의_정석\r\n#확실함_빼면_시체 #칼같음\r\n#항상_각잡혀있음 #진지한_행동가",
      detail2: "보호자 유형은 성취욕과 노련한 관리능력을 모두 가진 사람들로, \r\n자신만의 확고한 신념 아래 원대한 목표를 세우고 이를 체계적으로 달성해갑니다.목표를 향해 추진력 있게 나아가면서도, 동시에 꼼꼼히 체크하는 이들은 확실한 마무리로 주변 사람들에게 강력한 신뢰를 줍니다.\r\n특히 내부적으로는 자신의 팀(또는 조직)을 위험으로부터 보호하면서,\r\n외부적으로는 체계적이고 구체적인 실행방안을 통해 한 단계 한 단계 \r\n목표를 성취해 나갑니다",
      title: "오리지날 창조가 유형",
      card: AD,
      color: "#B931F0",
    },
    DR: DR,
    DE: DE,
    DA: DA,
    DD: DD,
  };

  useEffect(() => {
    if (!location.state?.result) {
      navigate("/test");
    } else if (!user.me) {
      navigate("/login");
    } else {
      setType(location.state?.result?.type || "RR");
      setType1(location.state?.result?.type?.substring(0, 1) || "R");
      // setType("E");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.state]);

  const payment = async (point) => {
    if (!user.independent) {
      if (user.point < point) {
        setMessage(true);
        return;
      }

      const temp = { ...location.state?.result, payment: point };
      ReportService.payment(temp).then((res) => {
        if (res.code === 200) {
          navigate("/result-detail", { state: { selectedItem: temp } });
          // setSelectedItem(temp);
        }
      });
    } else {
      setLoading(true);
      const response = await fetch(
        config.API_URL +
        "/download/" +
        location.state?.result?.userId +
        "/" +
        location.state?.result?.id +
        "/" +
        point,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "client-id": "kr.co.icru",
            "user-id": user.id,
            authorization: "Bearer " + getItem("access-token"),
          },
        }
      );

      if (response) {
        const blob = await response.blob();
        const fileName =
          user.name +
          (point === "premium" ? " 기질진단 프리미엄 레포트.pdf" : " 회복탄력성 레포트.pdf");

        // 가상 링크 DOM 만들어서 다운로드 실행
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        toast.success("파일다운로드를 성공하였습니다.");
      } else {
        toast.error("파일다운로드를 실패하였습니다.");
      }
      setLoading(false);
    }
  };

  return (
    <PageWrapper title={'Test'}>
        <Page container='fluid'>
        <Card className="w-100 m-0 shadow-none" style={{
          backgroundColor: 'black',
          // marginTop: -20,
          paddingTop: 20,
          overflow: 'hidden',
        }}>
          <CardBody className='text-center'>
            <div className='row g-3 text-center topmenu-container'>
              <div className='col-auto font font-28'>
                <div className='mt-30'>
                  본성은 본질로 부터
                </div>
              </div>
            </div>
            <div className='font-16 dark2 auto'
              style={{
                marginTop: 50,
                marginBottom: -300,
                backgroundColor: '#00FF94',
                maxWidth: 500,
                height: 500,
                borderRadius: 500,
              }}>
              <div className='auto' style={{ width: 300, paddingTop: 100 }}>
                칼 구스타프 융의 4가지 인지기능을 기반으로, 현존하는 79개의 심리유형 진단도구를 최초로 통합한 기질 유형 진단도구 입니다
              </div>
            </div>
          </CardBody>
        </Card>
        <Card className="w-100 m-0 shadow-none">
          <CardBody className='d-flex flex-row justify-content-center'>
            <div><b>
              ABOUT ICRU
            </b></div>
            <div style={{marginLeft: 10}}>
              ICRU는 I Can R.E.A.D yoU의 약자로, 칼 구스타프 융의 4가지 인지기능을 기반으로 현존하는
              79개의 심리유형 진단도구를 통합하여 연구개발 된 기질 진단 도구입니다.{""}
            </div>
          </CardBody>
        </Card>
        <Card className="w-100 m-0 shadow-none">
          <CardBody className='d-flex flex-column text-center justify-content-center'>
            <div className="mt-5">
              <img src={bg2Logo} width="200" />
            </div>
            <h3 className="mt-5">
              {user.name}님의 ICRU기질진단 결과.{""}
            </h3>
            <div className="mt-5">
              <div
                style={{
                  backgroundColor: "#FBFBFB",
                  padding: 20,
                  borderRadius: 4,
                }}
              >
                <h6>
                  먼저 사람에 대한 이해를 높여줄{""}
                </h6>
                <h5>
                  4가지 대표기질 알아보기.{""}
                </h5>
              </div>
            </div>
          </CardBody>
        </Card>
        <Card className="w-100 m-0 shadow-none align-items-center">
          <CardBody style={{ maxWidth: 889, }}>
            <div
              style={{
                borderLeft: "5px solid" + reportData[type1].color,
                paddingLeft: "20px",
                marginBottom: "30px",
              }}
            >
              <h5 style={{ color: reportData[type1].color }}>
                나는 어떤 라인?{""}
              </h5>
              <h4 variant="h3" color="dark" textAlign="left">
                <b>{reportData[type1].title}</b>
              </h4>
            </div>
            <img src={reportData[type1].bg} width={'100%'} />
          </CardBody>
        </Card>
        <div className="gradient-bg">
          <Card className="w-100 m-0 shadow-none align-items-center transparent">
            <CardBody className="text-center" style={{ maxWidth: 889, }}>
              <div className="font-18 white mt-5">나는 어떤 유형?</div>
              <div className="font-28 white mt-5 mb-5">그래서 최종 히어로 유형은...!</div>
              <img src={graph}/>

              <div className="font-18 white mt-5">그래프 분석 결과</div>
              <div className="font-28 white mt-5"><span style={{ color: reportData[type].color }}>{reportData[type].type}</span> 라인의</div>
              <div className="font-28 white"><span style={{ color: reportData[type].color }}>{reportData[type].title}</span></div>
            </CardBody>
          </Card>
          <Card className="m-0 shadow-none justify-content-center transparent">
            <CardBody className="row justify-content-center">
              <div className="col-12 col-lg-6 p-3 text-end">
                <img src={reportData[type].card} />
              </div>
              <div className="col-12 col-lg-6 p-3">
                <Card className="custom-shadow-box rounded-2" style={{backgroundColor: 'black', maxWidth: 400}}>
                  <CardBody>
                    <div className="font-28 mt-5" style={{ color: reportData[type].color }}>{reportData[type].en}</div>
                    <div className="font-18 mt-5 white">{user.name}{reportData[type].detail}</div>
                    <div className="font-18 mt-5" style={{ color: reportData[type].color }}>{reportData[type].tag}</div>
                    <div className="font-144 mt-5 white">{reportData[type].detail2}</div>
                  </CardBody>
                </Card>
              </div>
            </CardBody>
          </Card>
        </div>
        <Card className="m-0 shadow-none justify-content-center">
          <CardBody className="row justify-content-center">
            {payType === "free" && (
              <div className="col-12 col-md-4 p-5">
                <Card className="custom-shadow-box rounded-2" style={{ border: '1px solid #EFEFEF' }}>
                  <CardBody className="rounded-2">
                    <div>
                      <h5>
                        <Icon icon="Lock" />
                        <span style={{ marginLeft: 5 }}>베이직</span>
                      </h5>
                    </div>
                    <div className="mt-3">
                    <h6><b>
                      1,000 P
                    </b></h6>
                    </div>
                    <div className="mt-5">
                    {["기질안내", "최종유형 안내"].map((item) => (
                      <div key={item} className="mt-3">
                        <div
                          component="span"
                          variant="h6"
                          ml={1}
                          style={{
                            fontSize: "14px",
                            color: "#808080",
                          }}
                        >
                          <Icon icon="Verified" />
                          <span 
                            style={{
                              margin: 5,
                              color: "#808080",
                            }}
                          >
                            {item}
                          </span>
                        </div>
                      </div>
                    ))}
                    <div className="mt-3">&nbsp;</div>
                    </div>
                    <div className="w-100 align-items-center" style={{marginTop: 100}}>
                      <Button
                        isOutlined
                        className="w-100"
                        style={{
                          padding: 10,
                          border: '1px solid #D8D8D8',
                        }}
                        onClick={() => {
                          payment(1, "basic");
                        }}
                      >
                        베이직 결과 보기
                      </Button>
                    </div>
                  </CardBody>
                </Card>
              </div>
            )}
            <div className="col-12 col-md-4 p-5">
              <Card className="custom-shadow-box rounded-2" style={{ border: '1px solid #EFEFEF' }}>
                <CardBody className="rounded-2">
                  <div>
                    <h5>
                      <Icon icon="Lock" />
                      <span style={{ marginLeft: 5 }}>프리미엄</span>
                    </h5>
                  </div>
                  <div className="mt-3">
                    <h6><b>
                      {type === "free" ? '2,000 P' :  '3,000 P'}
                    </b></h6>
                  </div>
                  <div className="mt-5">
                    {["기질안내", "최종유형 안내", "솔루션 안내"].map((item) => (
                      <div key={item} className="mt-3">
                        <div
                          component="span"
                          variant="h6"
                          ml={1}
                          style={{
                            fontSize: "14px",
                            color: "#808080",
                          }}
                        >
                          <Icon icon="Verified" />
                          <span
                            style={{
                              margin: 5,
                              color: "#808080",
                            }}
                          >
                            {item}
                          </span>
                        </div>
                      </div>
                    ))}
                  </div>
                  <div className="w-100 align-items-center" style={{ marginTop: 100 }}>
                    <Button
                      color="dark"
                      className="w-100"
                      style={{
                        padding: 10,
                        border: '1px solid #D8D8D8',
                      }}
                      onClick={() => {
                        payment(type === "free" ? 3 : 2, "premium");
                      }}
                    >
                      프리미엄 결과 보기
                    </Button>
                  </div>
                </CardBody>
              </Card>
            </div>
            {message && (
              <div className="row text-center ">
                  <div>
                  <h6>보유한 포인트가 부족합니다.</h6>
                  </div>
                  <div>
                    <Button
                      isOutlined
                      isLink
                      color="info"
                    >
                      포인트 충전하기
                      <Icon icon="ArrowForwardIos" />
                    </Button>
                  </div>
              </div>
            )}
          </CardBody>
        </Card>
        <Card className="w-100 m-0 shadow-none align-items-center">
          <CardBody style={{ maxWidth: 889, }}>
            <img src={bg3Sample} width={'100%'} />
          </CardBody>
        </Card>
        <div
          width="100%"
          sx={{
            backgroundColor: "#ffffff",
            display: "div",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div container item xs={8} lg={8} justifyContent="center" mx="auto" mt={5}>
            <div component="img" src={reportData[type1].bg} width="120%" />

          </div>
          <div container item xs={8} lg={8} justifyContent="center" mx="auto" mt={2}>
            
          </div>
          <div
            container
            item
            xs={8}
            lg={8}
            display={"flex"}
            justifyContent="center"
            alignContent={"center"}
            mx="auto"
            mt={2}
          >
            <div py={2} px={2} component="img" src={reportData[type1].bg2} width="120%" />
          </div>
          {/* <div
              mt={3}
              py={1}
              display="flex"
              justifyContent="center"
              alignItems="center"
              style={{
                cursor: "pointer",
                border: "1px solid #eeeeee",
                borderRadius: "4px",
                background: "#000000",
              }}
              onClick={() => {
                payment("premium");
              }}
            >
              <div
                component="span"
                variant="h6"
                ml={1}
                style={{
                  color: "white",
                }}
              >
                ICRU 홈페이지로 가기
              </div>
            </div> */}
          {/* <div container item xs={8} lg={8} justifyContent="center" mx="auto" mt={2}>
              <Link to="/question" style={{ marginTop: 30 }}>
                <div component="img" src={basicBtn} />
              </Link>
              <Link to="/question">
                <div component="img" src={premiumBtn} />
              </Link>
            </div> */}
          <div container item xs={8} lg={8} justifyContent="center" mx="auto" mt={2}>
            <div component="img" src={bg3Sample} />
          </div>
        </div>
        <div pt={6} px={1} mt={0} style={{ backgroundColor: "#03FF99", justifyContent: "center" }}>
          {/* <Footer content={footerRoutes} /> */}
        </div>
        </Page>
        </PageWrapper>
  );
}

export default Report;
